// extracted by mini-css-extract-plugin
export var button = "_mj-2";
export var card = "_mj-0";
export var closeButtonContainer = "_mj-3";
export var iconContainer = "_mj-1";